import React from 'react';
import '../componentsCSS/Rgpd.css' // Importer le CSS spécifique à ce composant

const Rgpd = () => {
    return (
        <div className='wrapper-rgpd'>
            <h1>Politique de confidentialité</h1>

            <h2>Règlement Général sur la Protection des Données (RGPD)</h2>
            <br></br>
            <p>Dernière mise à jour : 26/10/2024</p>
            <br></br>
            <p>Nous prenons la protection de vos données personnelles très au sérieux. En utilisant notre plateforme, vous acceptez la collecte et le traitement de vos informations conformément à cette politique.</p>
            <br></br>

            <h2>1. Données collectées</h2>
            <p>Nous collectons les données suivantes :</p>
            <ul>
                <li><strong>Adresse e-mail</strong> : utilisée pour créer votre compte et permettre une authentification sécurisée.</li>
                <li><strong>Nom et prénom</strong> : nécessaires pour faciliter la prise de contact en cas de gain.</li>
                <li><strong>Nom de l’entreprise</strong> : afin de vérifier votre éligibilité à participer à ce jeu réservé à certaines entreprises.</li>
                <li><strong>Pseudo</strong> : pour personnaliser votre expérience sur notre plateforme.</li>
                <li><strong>Mot de passe </strong>: stocké sous forme cryptée pour sécuriser votre compte.</li>
            </ul>
            <br></br>

            <h2>2. Finalité des données</h2>
            <p>Vos données sont collectées pour les finalités suivantes :</p>
            <ul>
                <li>Gérer votre compte utilisateur et votre participation au jeu.</li>
                <li>Communiquer avec vous en cas de gain ou pour des informations liées au jeu.</li>
                <li>Garantir l’accès réservé aux employés d’entreprises éligibles.</li>
            </ul>
            <br></br>

            <h2>3. Durée de conservation</h2>
            <p>Vos données personnelles seront conservées :</p>
            <ul>
                <li>Pendant toute la durée du jeu.</li>
                <li>Et jusqu’à 6 mois après la fin du jeu pour des besoins de gestion administrative.</li>
            </ul>
            <br></br>

            <h2>4. Partage des données</h2>
            <p>Vos données ne seront jamais partagées avec des tiers sans votre consentement, sauf si la loi l’exige.</p>
            <br></br>

            <h2>5. Vos droits</h2>
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
            <ul>
                <li><strong>Droit d’accès </strong>: vous pouvez demander à consulter les données personnelles que nous détenons sur vous.</li>
                <li><strong>Droit de rectification </strong>: vous pouvez demander à corriger vos données si elles sont inexactes.</li>
                <li><strong>Droit de suppression </strong>: vous pouvez demander la suppression de vos données (ce qui entraînera la désactivation de votre compte).</li>
                <li><strong>Droit de limitation du traitement </strong>: dans certains cas, vous pouvez demander à limiter le traitement de vos données.</li>
            </ul>
            <p>Pour exercer vos droits, contactez-nous à contact.secretforsides@forsides.com.</p>
            <br></br>

            <h2>6. Sécurité des données</h2>
            <p>Nous mettons en œuvre toutes les mesures techniques et organisationnelles nécessaires pour protéger vos données.</p>
            <br></br>

            <h2>7. Modifications</h2>
            <p>Nous nous réservons le droit de modifier cette politique à tout moment. Vous serez informé(e) en cas de changements significatifs.</p>
            <br></br>
        </div>
    )
};

export default Rgpd;